import { render, staticRenderFns } from "./admin-company-promotions.vue?vue&type=template&id=4c7a5eca&"
import script from "./admin-company-promotions.ts?vue&type=script&lang=ts&"
export * from "./admin-company-promotions.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports